import api from '../../utils/api';
import { alertError, alertSuccess } from './alert';
import {
  DROPSHIP_REVENUE,
  DROPSHIP_ALLOWED,
  REPLENISH_ALLOWED,
  PERMISSIONS_TAB,
  PERMISSIONS_MINIMUM_ORDER_PRODUCTS,
  PERMISSIONS_MINIMUM_ORDER_VALUE,
  PERMISSIONS_FIXED_PER_UNIT,
  PERMISSIONS_PERCENTAGE,
  PERMISSIONS_CHANGED,
  REPLENISH_SHIPPER_ACCOUNT,
  REPLENISH_DAYS_UNTIL_OVERDUE,
  ECOMMERCE_DAYS_UNTIL_OVERDUE,
} from '../constants/permissionsTypes';
import { updateRetailer } from './retailer';

export const setPermissionsChanged = (value) => ({ type: PERMISSIONS_CHANGED, payload: value });
export const setReplenishShipperAccount = (provider, account) => ({
  type: REPLENISH_SHIPPER_ACCOUNT,
  payload: { provider, account },
});
export const setDropshipAllowed = (value) => ({ type: DROPSHIP_ALLOWED, payload: value === 'true' });
export const setReplenishAllowed = (value) => ({ type: REPLENISH_ALLOWED, payload: value === 'true' });
export const setPermissionsMinimumOrderProducts = (value) => ({
  type: PERMISSIONS_MINIMUM_ORDER_PRODUCTS,
  payload: value || 0,
});
export const setPermissionsMinimumOrderValue = (value) => ({
  type: PERMISSIONS_MINIMUM_ORDER_VALUE,
  payload: value || 0,
});
export const setPermissionsFixedPerUnit = (value) => ({ type: PERMISSIONS_FIXED_PER_UNIT, payload: value });
export const setPermissionsPercentage = (value) => ({ type: PERMISSIONS_PERCENTAGE, payload: value });

export const setPermissionsTab = (value) => ({ type: PERMISSIONS_TAB, payload: value });
export const setReplenishDaysUntilOverdue = (days) => ({ type: REPLENISH_DAYS_UNTIL_OVERDUE, payload: days });
export const setEcommerceDaysUntilOverdue = (days) => ({ type: ECOMMERCE_DAYS_UNTIL_OVERDUE, payload: days });

export const setDropshipRevenue = (commission_type, value) => ({
  type: DROPSHIP_REVENUE,
  commission_type,
  payload: value,
});

let cancelPostPermissions;
export const postPermissions = (supplierId, data) => {
  if (cancelPostPermissions) {
    cancelPostPermissions('Cancel post permissions');
  }

  return api.post(`/suppliers/${supplierId}/permissions`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPostPermissions = c)),
  });
};

let cancelPutPermissions;
export const putPermissions = (id, data) => async (dispatch, getState) => {
  try {
    if (cancelPutPermissions) {
      cancelPutPermissions('Cancel put permissions');
    }

    const { supplierId } = getState().role;

    await api.put(`/suppliers/${supplierId}/retailers/${id}`, data, {
      cancelToken: new api.CancelToken((c) => (cancelPutPermissions = c)),
    });

    dispatch(alertSuccess('Success'));
    dispatch(setPermissionsChanged(false));
    dispatch(updateRetailer(data));
  } catch (error) {
    dispatch(alertError(error));
  }
};

let cancelPutRetailersPermissions;
export const putRetailersPermissions = (retailerId, data) => {
  if (cancelPutRetailersPermissions) {
    cancelPutRetailersPermissions('Cancel put retailers permissions');
  }

  return api.put(`/retailers/${retailerId}/permissions`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPutRetailersPermissions = c)),
  });
};
